export default () => {
  return (
    <div className="search-results__spinner">
      <img src="/areas/EGH/assets/img/gif/loading-spinner.gif" />
    </div>
  );
};
